import React, { useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Table,
  TabPane,
} from "reactstrap"
import classNames from "classnames"
import { productImages } from "assets/images/product"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

const product = {
  id: "ID-254832555",
  name: "Product Name",
  category: "Category Name",
  createdAt: "25 dec, 2022",
  price: 2000,
  couponBased: true,
  pin: true,
  desciption:
    "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  tag: ["Tag 1", "Tag 2", "Tag 3"],
  salesCount: "100 Units",
  availableStock: 200,
  lowStock: 5,
  visibility: true,
  subImage: [
    {
      id: "1",
      cover: true,
      imgSrc:
        "https://img.freepik.com/premium-photo/mineral-water-bottle-water-glass-with-spash-blue-background-with-copy-space-vertical-format_138656-1131.jpg?w=360",
    },
    {
      id: "2",
      cover: false,
      imgSrc:
        "https://i.pinimg.com/736x/a9/ee/32/a9ee32f627c6105ea0968fe47afe5d89.jpg",
    },
  ],
  composition1: [
    {
      name: "PH",
      value: "7.1",
    },
    {
      name: "Sodium",
      value: "7.5",
    },
    {
      name: "Potassium",
      value: "20",
    },
  ],
  composition2: [
    {
      name: "Calcium",
      value: "36",
    },
    {
      name: "Sulphate",
      value: "24",
    },
    {
      name: "Tds",
      value: "175",
    },
  ],
}
const ProductDetails = () => {
  const [activeTab, setActiveTab] = useState("0")
  const [copied, setCopied] = useState(false)
  const { t } = useTranslation()

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const imageShow = (img: string, id: number) => {
    const expandImg = document.getElementById("expandedImg" + id)
    if (expandImg) {
      ;(expandImg as HTMLImageElement).src = img
    }
  }

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500) // يختفي بعد 1.5 ثانية
    })
  }

  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("products_products")}
          subBreadcrumbItem={t("products_name")}
        />
        <div className="d-flex gap-2">
          <Button
            onClick={() => {}}
            className="bg-gradiant-blue border-0 text-capitalize"
          >
            {t("products_editProduct")}
          </Button>
          <Button
            onClick={() => {}}
            className="bg-transparent border text-danger border-danger text-capitalize"
          >
            {t("products_deleteProduct")}
          </Button>
        </div>
      </div>
      <Card className="shadow-md rounded-3">
        <CardBody>
          <Row>
            <Col xl={4}>
              <div className="product-detai-imgs">
                <TabContent activeTab={activeTab}>
                  {product.subImage.length &&
                    product.subImage.map((item, index) => (
                      <TabPane tabId={index.toString()} key={item.id}>
                        <div>
                          <img
                            src={item.imgSrc}
                            alt=""
                            id="expandedImg1"
                            className="img-fluid mx-auto d-block"
                            style={{ maxWidth: "300px" }}
                          />
                        </div>
                      </TabPane>
                    ))}
                </TabContent>
                <Nav
                  className="flex bg-transparent bg-none justify-content-center"
                  pills
                >
                  {product.subImage.length &&
                    product.subImage.map((item, index) => (
                      <NavItem key={item.id}>
                        <NavLink
                          className={classNames(
                            {
                              active: activeTab === index.toString(),
                            },
                            "p-1 position-relative overflow-hidden"
                          )}
                          onClick={() => {
                            toggleTab(index.toString())
                          }}
                          style={{ width: "62px", height: "62px" }}
                        >
                          <img
                            src={item.imgSrc}
                            alt=""
                            onClick={() => {
                              imageShow(item.imgSrc, index + 1)
                            }}
                            className="img-fluid mx-auto d-block rounded w-100"
                          />
                          <button
                            className="position-absolute p-0 border-0 translate-middle text-danger fw-bold bg-white rounded-circle text-center"
                            style={{
                              top: "15px",
                              left: "45px",
                              width: "16px",
                              height: "16px",
                            }}
                          >
                            <i className="bx bx-x bx-xs fw-bolder "></i>
                          </button>
                          {item.cover && (
                            <p
                              className="position-absolute m-auto w-90 text-semi-dark fw-bold bg-semi-white-60 rounded-2 text-center font-size-10 px-2"
                              style={{ bottom: "10px", left: "8px" }}
                            >
                              {t("common_cover")}
                            </p>
                          )}
                        </NavLink>
                      </NavItem>
                    ))}
                </Nav>
              </div>
            </Col>

            <Col xl="8">
              <div className="mt-4 mt-xl-3">
                <div className="d-flex justify-content-between">
                  <h4 className="text-semi-dark fw-semibold m-0">
                    {product.name}
                  </h4>
                  <p className="text-semi-dark fw-semibold font-size-16">
                    {t("common_qar")} {product.price}
                  </p>
                </div>
                <p>
                  <span className="fw-regular font-size-16 ">
                    {product.category}
                  </span>
                  <span className="font-size-12 px-3">
                    {t("common_createdAt")} {product.createdAt}
                  </span>
                </p>

                <div className="d-flex gap-2 mb-4">
                  {product.couponBased && (
                    <Badge className="bg-primary text-white font-size-12 p-2">
                      {t("products_couponBased")}
                    </Badge>
                  )}
                  {product.pin && (
                    <Badge className="bg-primary text-white font-size-12 p-2">
                      {t("products_pin")}
                    </Badge>
                  )}
                  {product.tag &&
                    product.tag.map((tag, index) => (
                      <span
                        key={index}
                        className="badge bg-primary-30 text-primary font-size-12 p-2"
                      >
                        {tag}
                      </span>
                    ))}
                </div>
                <div className="d-flex justify-content-between mb-4">
                  <p className="text-muted mb-0">
                    <span className="font-size-16 fw-semibold text-semi-dark">
                      {t("products_productId")}
                    </span>
                    <span className="font-size-16 fw-regular text-black px-3">
                      {product.id}
                    </span>
                  </p>
                  <button
                    className="position-relative cursor-pointer border-0 bg-transparent"
                    onClick={() => {
                      copyToClipboard(product.id)
                    }}
                  >
                    <i className="bx bx-copy px-2 text-primary bx-sm cursor-pointer"></i>
                    {copied && (
                      <span
                        className="position-absolute  translate-middle-x mt-1 text-success small"
                        style={{ top: "0", left: "-7px" }}
                      >
                        {t("common_copied")}
                      </span>
                    )}
                  </button>
                </div>

                <div className="text-muted float-start mb-4">
                  <p className="text-semi-dark font-size-14 fw-regular mb-0">
                    {product.desciption}
                  </p>
                </div>

                <div className="mb-4">
                  <span className="font-size-16 fw-semibold text-semi-dark">
                    {t("products_salesCount")}
                  </span>
                  <span className="font-size-16 fw-regular text-black px-3">
                    {product.salesCount}
                  </span>
                </div>

                <div className="d-flex justify-content-between mb-4">
                  <p className="text-muted mb-0">
                    <span className="font-size-16 fw-semibold text-semi-dark">
                      {t("products_availableStock")}
                    </span>
                    <span className="font-size-16 fw-regular text-black px-3">
                      {product.availableStock}
                    </span>
                  </p>
                  <p className="text-muted mb-0">
                    <span className="font-size-16 fw-semibold text-semi-dark">
                      {t("products_lowStock")}
                    </span>
                    <span className="font-size-16 fw-regular text-black px-3">
                      {product.lowStock} {t("products_default")}
                    </span>
                  </p>
                </div>

                <Row>
                  <Col lg={6}>
                    <div className="table-responsive shadow-md">
                      <Table className="table mb-0 table-bordered rounded-3 overflow-hidden ">
                        <thead>
                          <th
                            scope="row"
                            style={{ width: "400px" }}
                            className={"text-capitalize p-2"}
                          >
                            {t("products_composition")}
                          </th>
                          <th className="p-2">{t("products_value")}</th>
                        </thead>
                        <tbody>
                          {product.composition1 &&
                            product.composition1.map((specification, i) => (
                              <tr key={i}>
                                <td
                                  scope="row"
                                  style={{ width: "400px" }}
                                  className={"text-capitalize"}
                                >
                                  {specification.name}
                                </td>
                                <td>{specification.value}</td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="table-responsive shadow-md">
                      <Table className="table mb-0 table-bordered rounded-3 overflow-hidden ">
                        <thead>
                          <th
                            scope="row"
                            style={{ width: "400px" }}
                            className={"text-capitalize p-2"}
                          >
                            {t("products_composition")}
                          </th>
                          <th className="p-2">{t("products_value")}</th>
                        </thead>
                        <tbody>
                          {product.composition2 &&
                            product.composition2.map((specification, i) => (
                              <tr key={i}>
                                <td
                                  scope="row"
                                  style={{ width: "400px" }}
                                  className={"text-capitalize"}
                                >
                                  {specification.name}
                                </td>
                                <td>{specification.value}</td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>

                <div className="d-flex gap-2 align-items-center mt-4">
                  <p className="text-semi-dark text-start">
                    <b>{t("products_productVisibility")}</b>
                    <span> ({t("products_productVisibilityInfo2")})</span>
                  </p>
                  <div className="form-check form-switch mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`customSwitch${product.id}`}
                      checked={product.visibility}
                      onChange={() => {}}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  )
}

export default ProductDetails
